module.exports = __webpack_public_path__ + "media/customizations/sunterra/logo-new-249966feb2a3b0f61047fad4578c0e7d.png";